var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDorianWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 125 125",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.245 45.072h-13.07l.268 13.63M64.936 7.149c30.687 0 55.563 24.876 55.563 55.562 0 30.687-24.877 55.563-55.563 55.563M68.408 7.154H5.524V43.58m60.639 74.657H5.5V83.278m53.231-38.263c10.715 0 19.4 7.968 19.4 17.797 0 9.828-8.685 17.796-19.4 17.796m-.145-.026H46.775m31.473-18.305 41.694-.535M54.462 7.225l-.268 19.227m5.98.866c15.21 0 29.264 7.034 36.87 18.452m-.152 36.526c-7.605 11.418-21.66 18.452-36.87 18.452m.576-73.483-36.606-.011v73.237l36.03.257M23.726 63.881l-19.51-.268",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDorianWhite);
export default __webpack_public_path__ + "static/media/dorian-white.163ff51a0d73c2c299d99dbe607f5eb3.svg";
export { ForwardRef as ReactComponent };